import { createAction } from 'redux-act';
import { INavigate, types } from './types';

export const navigate = createAction<INavigate>(types.NAVIGATE);
